// **************** common import *******************
import React from "react";
import NotesErrorList from "./notes_error_list";


// interface 
import { ChildProps } from "../../utils/types/interFace";

const Index = ({filteredAccess}:ChildProps) => {
  const PageDetail = {
    error:'virtual_fax',
    pageTitle:'Outbound eFax',
    pageDescription:'Encountered an error while sending notes from Virtual Fax',
    pageNote:"System Errors ( WIll not require any user intervention.  Scribe Smart  Maintenance team( India Team) will take care of these errors. However, they wanted to display the issues for everyone's reference)"
  }
  return <NotesErrorList filteredAccess={filteredAccess} pageDetails={PageDetail} />
};

export default Index;